import { useStoreCaseConfiguration } from '@/Store/storeCaseConfiguration';
import { useStoreProjectStructure } from '@/Store/storeProjectStructure';

export function deleteCase(caseId: string) {
    if (!caseId) {
        console.log('Нет выбранного шкафа!');
        return;
    }
    useStoreCaseConfiguration().resetStoreConfiguration();
    useStoreProjectStructure().deleteCaseById(caseId);

    const newSelectedCase = useStoreProjectStructure().cases[0]?.id;
    useStoreProjectStructure().setSelectedCaseId(newSelectedCase);
}
